import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    .ant-card-body {
        height: 146px;
        padding: 16px;
    }
`;
